import React from 'react'
import { ErrorPageBase } from './ErrorPageBase'

export const NotFoundPage = () => 
    <ErrorPageBase title='404 Not Found' 
        descr = {<>
            This link does not lead to a valid resource<br />
            Please check the website address
        </>} />
